export const SUBMISSION_MODE_OPTIONS = [
  {
    label: 'Both',
    description:
      'No restrictions. This template can be used for project-based or adhoc submissions.',
    value: 'BOTH',
  },
  {
    label: 'Project-based Submissions Only',
    description:
      'This template can only be used for submissions tied to a project.',
    value: 'TASK',
  },
  {
    label: 'Adhoc Submissions Only',
    description: 'This template can only be used for adhoc submissions.',
    value: 'ADHOC',
  },
];
